"use client";

import { useLightMode } from "@/hooks/use-feature-flag";
import { usePreferredTheme } from "@/hooks/use-theme";
import type { ThemeMode } from "@/lib/themes/types";
import { type ReactNode, useEffect } from "react";
import { ThemeContext } from "../lib/themes/store";

export function ThemeProvider({
	children,
}: {
	children: ReactNode;
}): React.ReactElement {
	const [currentMode, changeMode] = usePreferredTheme({ defaultMode: "dark" });
	const isLightModeAvailable = useLightMode();

	useEffect(() => {
		if (!currentMode) {
			return;
		}
		const root = document.documentElement;
		root.setAttribute("data-color-mode", currentMode);
	}, [currentMode]);

	const changeModeHandler = (mode: ThemeMode): void => {
		if (isLightModeAvailable) {
			changeMode(mode);
		}
	};

	return (
		<ThemeContext.Provider
			value={{ mode: currentMode, changeMode: changeModeHandler }}
		>
			{children}
		</ThemeContext.Provider>
	);
}
